export default "__VITE_ASSET__Bhx2KinQ__"